import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { useHistory, useLocation } from 'react-router-dom';

const AppUrlListener = ({ routeListener, getUserProvider, getUserInfo }) => {
  const history = useHistory();
  const location = useLocation();

  const incomingRouteListener = (incomingRoute) => {
    routeListener(getUserInfo, getUserProvider, incomingRoute, (routePath) => {
      if (routePath) {
        history.push(routePath);
      }
    });
  };

  const handleRedirectEvent = (event) => {
    const route = event.detail;
    const landingRoute = route || '';
    incomingRouteListener(landingRoute);
  };

  useEffect(() => {
    window.addEventListener('redirectTo', handleRedirectEvent);
    if (Capacitor.isNativePlatform()) {
      incomingRouteListener(`${location.pathname.substring(1)}${location.search}`);
    }
    return () => window.removeEventListener('redirectTo', handleRedirectEvent);
  }, []);

  return null;
};

export default AppUrlListener;
